import Vue from 'vue'
import simpleNotification from '../views/components/alert_dynamic.vue'

Vue.component('simple-notif', simpleNotification);